import {AlertsAction, AlertsActionType} from './alerts.action';
import {initialAlertsState, AlertsState} from './alerts.state';

export function alertsReducer(state: AlertsState = initialAlertsState, action: AlertsAction): AlertsState {
  switch (action.type) {
    case AlertsActionType.GET_SUCCESS:
      return {...state, alerts: action.payload.alerts};
    case AlertsActionType.GET_COUNT_SUCCESS:
      return {...state, unreadAlertsCount: action.payload.count};
    case AlertsActionType.CLEAR:
      return initialAlertsState;
    default:
      return state;
  }
}
